import { QarepaEnumInformation } from '@qarepa/common';

export enum UserRoleEnum {
  ADMIN = 'ADMIN',
  DEVELOPER = 'DEVELOPER',
  EMPLOYEE = 'EMPLOYEE',
  HR = 'HR',
  MANAGER = 'MANAGER',
  NONE = 'NONE',
  OWNER = 'OWNER',
  WORKSTATION = 'WORKSTATION',
}

export type UserRoleType =
  | UserRoleEnum.ADMIN
  | UserRoleEnum.DEVELOPER
  | UserRoleEnum.EMPLOYEE
  | UserRoleEnum.HR
  | UserRoleEnum.MANAGER
  | UserRoleEnum.NONE
  | UserRoleEnum.OWNER
  | UserRoleEnum.WORKSTATION;

export const UserRoleArray = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.DEVELOPER,
  UserRoleEnum.EMPLOYEE,
  UserRoleEnum.HR,
  UserRoleEnum.MANAGER,
  UserRoleEnum.NONE,
  UserRoleEnum.OWNER,
  UserRoleEnum.WORKSTATION,
];

export const AllAdminRoles = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.HR,
  UserRoleEnum.MANAGER,
  UserRoleEnum.OWNER,
  UserRoleEnum.WORKSTATION,
];

export const fullAccessAdminRoles = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.HR,
  UserRoleEnum.OWNER,
  UserRoleEnum.WORKSTATION,
];

export const adminOnlyRoles = [UserRoleEnum.ADMIN];

export const UserRoleInfo: QarepaEnumInformation<UserRoleEnum> = {
  [UserRoleEnum.ADMIN]: {
    name: $localize`Administrador`,
  },
  [UserRoleEnum.EMPLOYEE]: {
    name: $localize`Empleado`,
  },

  [UserRoleEnum.DEVELOPER]: {
    name: $localize`Desarrollador`,
  },
  [UserRoleEnum.HR]: {
    name: $localize`Recursos Humanos`,
  },
  [UserRoleEnum.MANAGER]: {
    name: $localize`Mánager`,
  },
  [UserRoleEnum.NONE]: {
    name: $localize`Ninguno`,
  },
  [UserRoleEnum.OWNER]: {
    name: $localize`Propietario`,
  },
  [UserRoleEnum.WORKSTATION]: {
    name: $localize`Máquina de fichaje`,
  },
};

export enum UserRoleHintEnum {
  ADMIN = 'ADMIN',
  HR = 'HR',
  MANAGER = 'MANAGER',
  WORKSTATION = 'WORKSTATION',
}

export const UserRoleHintInfo: QarepaEnumInformation<UserRoleHintEnum> = {
  [UserRoleEnum.ADMIN]: {
    name: $localize`Administrador de la Empresa`,
  },
  [UserRoleEnum.HR]: {
    name: $localize`Gestión de Recursos Humanos`,
  },
  [UserRoleEnum.MANAGER]: {
    name: $localize`Gestión de Empleados`,
  },
  [UserRoleEnum.WORKSTATION]: {
    name: $localize`Máquina de fichaje`,
  },
};

export const InvitationRoleSelectorArray = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.MANAGER,
];

export const UpdateRoleArray = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.MANAGER,
  UserRoleEnum.EMPLOYEE,
];

export const FilterUsersSelectorArray = [
  UserRoleEnum.ADMIN,
  UserRoleEnum.MANAGER,
  UserRoleEnum.EMPLOYEE,
];
